export default "__VITE_ASSET__DyOX0x70__"